import * as React from 'react';

function ProvidersIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 15 15" fill="none" {...props}>
			<path
				d="M10.75 4a3.25 3.25 0 010 6.5h-6.5a3.25 3.25 0 110-6.5h6.5zM4.96 5.756c-.298 0-.541.243-.541.542v.473h-.474a.542.542 0 000 1.084h.474v.474a.542.542 0 001.084 0v-.474h.474a.542.542 0 000-1.084h-.474v-.473a.542.542 0 00-.542-.542zM9.126 6.77a.542.542 0 000 1.084h1.523a.542.542 0 000-1.084H9.125z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default ProvidersIcon;
